function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M456.348,367.294h-44.522c-6.144,0-11.13-4.986-11.13-11.13s4.986-11.13,11.13-11.13h44.522 c18.41,0,33.391-14.982,33.391-33.391V66.772c0-18.41-14.982-33.391-33.391-33.391H55.653c-18.41,0-33.391,14.959-33.391,33.391 v244.87c0,18.41,14.982,33.391,33.391,33.391h44.522c6.144,0,11.13,4.964,11.13,11.13c0,6.166-4.986,11.13-11.13,11.13H55.653 C24.977,367.294,0,342.317,0,311.641V66.772C0,36.096,24.977,11.12,55.653,11.12h400.696C487.046,11.12,512,36.074,512,66.772 v244.87C512,342.317,487.046,367.294,456.348,367.294z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M256.023,211.801c-11.91,0-23.819-3.718-33.992-11.153L49.152,75.788c-5.009-3.606-6.122-10.552-2.515-15.538 c3.584-5.009,10.529-6.122,15.538-2.515L235.142,182.64c12.533,9.149,29.251,9.149,41.695,0.045l172.989-124.95 c4.986-3.584,11.932-2.493,15.538,2.493c3.606,4.986,2.471,11.954-2.493,15.538L289.904,200.671 C279.797,208.084,267.91,211.801,256.023,211.801z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M55.653,322.772c-2.849,0-5.699-1.091-7.88-3.25c-4.341-4.341-4.341-11.398,0-15.738l111.304-111.304 c4.341-4.341,11.398-4.341,15.738,0c4.341,4.341,4.341,11.398,0,15.738L63.511,319.522 C61.351,321.681,58.502,322.772,55.653,322.772z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M456.348,322.772c-2.849,0-5.699-1.091-7.88-3.25L337.164,208.217c-4.341-4.341-4.341-11.398,0-15.738 c4.341-4.341,11.398-4.341,15.738,0l111.304,111.304c4.341,4.341,4.341,11.398,0,15.738 C462.047,321.681,459.198,322.772,456.348,322.772z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M256.067,500.881c-0.69,0-1.38,0-2.07-0.022c-32.701-0.534-63.221-13.779-85.971-37.287 c-46.948-48.529-45.657-126.175,2.849-173.101c23.507-22.751,54.984-34.994,87.151-34.438c32.679,0.534,63.221,13.779,85.971,37.265 c22.194,22.951,34.438,53.181,34.438,85.126c0,6.144-4.986,11.13-11.13,11.13s-11.13-4.986-11.13-11.13 c0-26.134-10.017-50.866-28.205-69.654c-18.61-19.211-43.587-30.052-70.344-30.497c-26.223,0-52.068,9.594-71.302,28.205 c-39.691,38.4-40.737,101.933-2.315,141.624c18.61,19.233,43.587,30.074,70.344,30.497c26.847,0.935,52.046-9.572,71.302-28.182 c4.408-4.252,11.464-4.163,15.738,0.267s4.163,11.464-0.267,15.738C318.13,488.682,288.012,500.881,256.067,500.881z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M256,434.076c-30.675,0-55.652-24.977-55.652-55.652s24.977-55.652,55.652-55.652s55.652,24.954,55.652,55.652 S286.676,434.076,256,434.076z M256,345.033c-18.41,0-33.391,14.982-33.391,33.391c0,18.41,14.982,33.391,33.391,33.391 s33.391-14.982,33.391-33.391C289.392,360.014,274.41,345.033,256,345.033z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M333.913,434.076c-27.871,0-44.522-20.814-44.522-55.652c0-6.144,4.986-11.13,11.13-11.13c6.144,0,11.13,4.964,11.13,11.13 c0,22.15,7.502,33.391,22.261,33.391c16.651,0,22.261-8.437,22.261-33.391c0-6.144,4.986-11.13,11.13-11.13s11.13,4.964,11.13,11.13 C378.435,392.181,378.435,434.076,333.913,434.076z"
});

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD54F"
    },
    d: "M501.315,34.048L314.101,169.395l-30.72,22.261c-16.273,12.021-38.489,12.021-54.762,0l-30.72-22.261 L10.463,34.271c10.418-14.581,27.27-23.218,45.19-23.151h400.696C474.135,11.12,490.853,19.646,501.315,34.048z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M10.463,34.271L197.9,169.395L16.251,351.043C5.81,340.581-0.022,326.4,0,311.641V66.772 C-0.044,55.085,3.607,43.71,10.463,34.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M512,66.772v244.87c0.022,14.759-5.81,28.939-16.25,39.402L314.101,169.395L501.315,34.048 C508.261,43.532,512,54.996,512,66.772z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M333.913,411.815c-14.781,0-22.261-11.13-22.261-33.391c0.356-31.098-24.554-56.609-55.652-56.966 s-56.609,24.554-56.966,55.652c-0.356,31.098,24.554,56.609,55.652,56.966c16.673,0.2,32.568-7.012,43.409-19.656 c7.391,12.666,21.17,20.235,35.818,19.656c44.522,0,44.522-41.895,44.522-55.652c0-67.629-54.806-122.435-122.435-122.435 s-122.435,54.806-122.435,122.413S188.372,500.837,256,500.837c31.766,0,62.286-12.355,85.126-34.438 c4.43-4.296,4.519-11.375,0.223-15.783c-4.296-4.43-11.375-4.519-15.805-0.223l0,0c-39.825,38.4-103.246,37.265-141.646-2.56 s-37.265-103.246,2.56-141.646s103.246-37.265,141.646,2.56c18.031,18.699,28.093,43.676,28.071,69.654 C356.174,403.379,350.565,411.815,333.913,411.815z M256,411.815c-18.432,0-33.391-14.959-33.391-33.391 c0-18.432,14.959-33.391,33.391-33.391s33.391,14.937,33.391,33.391C289.392,396.878,274.432,411.815,256,411.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA000"
    },
    d: "M314.101,169.395l-30.72,22.261c-16.273,12.021-38.489,12.021-54.762,0l-30.72-22.261L16.251,351.043 c10.463,10.44,24.643,16.273,39.402,16.25h56.209c6.033-79.605,75.442-139.242,155.025-133.231 c71.235,5.387,127.844,61.997,133.231,133.231h56.231c14.759,0.022,28.939-5.81,39.402-16.25L314.101,169.395z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.23be8130.svg";
export { ForwardRef as ReactComponent };